import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteFeed } from '../../../api/feeds';
import { routes } from '../../../constants/RouterPath';
import { createRequest } from '../../../helpers/api/createRequest';
import { Thunk } from '../../../helpers/redux/Thunk';
import { history } from '../../../store/history';
import { TypesIcon } from '../../../types/TypesIcon';
import { TypesSnackbars } from '../../../types/TypesSnackbars';
import { addNotification } from '../../notifications';

export const DELETE_FEED = 'feeds/getFeed';

const onSuccess = (): Thunk => dispatch => {
    dispatch(addNotification({
        type: TypesSnackbars.SUCCESS,
        message: {
            title: 'Фид удален успешно',
        },
        icon: TypesIcon.SNACK_SUCCES,
    }));

    history.replace(routes.feeds);
};

export const deleteFeedThunk = createAsyncThunk(
    DELETE_FEED,
    createRequest({
        type: DELETE_FEED,
        loader: async (id: number) => deleteFeed(id),
        onSuccess,
    }),
);
